import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-enterprise';

export abstract class BaseCellRenderer<TValue, TParams extends ICellRendererParams<any, TValue, any>> implements ICellRendererAngularComp {

  abstract displayLogic(params: TParams): void;

  agInit(params: TParams) {
    this.displayLogic(params);
  }

  refresh(params: TParams): boolean {
    this.displayLogic(params);
    return true;
  }
}
